<template>
    <div>
        <!--检索-->
        <el-row v-if="searchLabel">
            <el-col>
                <el-form :inline="true" :model="requestData" label-width="120px" style="text-align: right">
                    <el-form-item>
                        <el-input clearable size="medium" :placeholder="placeholder" v-model="searchText">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="medium" @click="search">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <!--表格数据-->
        <el-table
                v-if="tableData"
                :data="tableData"
                stripe
                style="width: 100%; margin-top: 20px;">
            <el-table-column
                    prop="award_name"
                    label="标题">
            </el-table-column>

            <el-table-column
                    prop=""
                    label="操作"
                    width="200"
                    align="right">
                <template slot-scope="scope">
                    <span v-if="!scope.row.activity_id">奖励规则未关联活动</span>
                    <el-button v-else type="text" size="small" @click="select(scope.row, scope.row.id)"
                               v-text="idList.indexOf(scope.row.id) !== -1 ? '已选取' : '选取'"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="tableData" class="pagination-wrapper">
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="requestData.count"
                    layout="total, prev, pager, next"
                    :total="totalNumber">
            </el-pagination>
        </div>
        <el-row type="flex" justify="center">
            <div class="bottom-btn-box">
                <el-button class="btn-long" type="primary" @click="closeDialog">关闭</el-button>
            </div>
        </el-row>
    </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      // 请求的URL
      url: {
        default: '',
        type: String
      },
      // 搜索的字段
      searchField: {
        default: '',
        type: String
      },
      // 搜索placeholder提示
      searchLabel: {
        default: '',
        type: String
      },
      // 服务端返回的数组名称
      resultArrayName: {
        default: '',
        type: String
      },
      // 标题名称
      titleName: {
        default: '',
        type: String
      },
      // 分页数量
      count: {
        default: 10,
        type: Number
      },
      // 是否支持多选
      multi: {
        type: Boolean,
        default: false
      },
      // 已选中的idlist
      idList: {
        type: Array,
        default: []
      },
      useType: {
        type: String,
        default: 'tms',
      }
    },
    data() {
      return {
        searchText: '',
        // 表格数据 & 翻页
        tableData: null,
        totalNumber: 0,
        currentPage: 1,

        requestData: {
          // 翻页参数
          offset: 0,
          count: 10
        },
      }
    },
    watch: {
      url(val) {
        this.requestData[this.searchField] = '';
        this.request();
      }
    },
    computed: {
      placeholder() {
        return `根据${this.searchLabel}进行搜索`;
      }
    },
    created() {
      this.requestData.count = this.count;
      this.request();
    },
    methods: {
      request() {
        // 有搜索字段时才设置搜索信息
        if (this.searchField) {
          this.requestData[this.searchField] = this.searchText;
        } else {
          delete this.requestData[this.searchField];
        }
        // 如果是默认页面，不用请求接口
        lib.api.get({
          api: this.url,
          data: this.requestData,
          success: (res) => {
            let data = res.data;
            data.data.map((val) => {
              val.name = val[this.titleName];
            })
            this.tableData = data.data;
            this.totalNumber = data.total_count;
          },
          error: (data) => {
            this.$message.error(data.msg || '请求失败!');
          },
          complete: () => {

          }
        })
      },
      search() {
        this.request();
      },
      /**
       * 选取记录
       * @param row 选取的记录对象
       * @param index 选取的记录在已选记录列表中的索引
       */
      select(row, index) {
        if(row.activity_id<=0){
          this.$message.error(row.award_name+':未关联活动！请先关联活动。');
          return ;
        }
        this.idList[0] = index;
        this.$emit('select', row);
      },
      handleCurrentChange(val) {
        this.requestData.offset = this.requestData.count * (val - 1) || 0;
        this.request();
      },
      closeDialog() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="sass">
</style>
